import { COUNTRY_CODES } from './country-codes';
export function getCountryField(
// required will be replaced with FieldSettings country once we have it in the proto
required, multilineAddressOptions) {
  var _multilineAddressOpti, _multilineAddressOpti2;
  return {
    id: '1e445376-d280-4cda-9ffa-18b61c2881c7',
    target: 'country',
    pii: true,
    hidden: false,
    view: {
      fieldType: 'MLA_COUNTRY',
      options: multilineAddressOptions != null && (_multilineAddressOpti = multilineAddressOptions.allowedCountries) != null && _multilineAddressOpti.length ? multilineAddressOptions == null ? void 0 : multilineAddressOptions.allowedCountries.map(country => ({
        value: country
      })) : Object.keys(COUNTRY_CODES).map(country => ({
        value: country
      }))
    },
    validation: {
      required: Boolean(required),
      string: {
        enum: multilineAddressOptions != null && (_multilineAddressOpti2 = multilineAddressOptions.allowedCountries) != null && _multilineAddressOpti2.length ? multilineAddressOptions == null ? void 0 : multilineAddressOptions.allowedCountries : Object.keys(COUNTRY_CODES)
      }
    }
  };
}
export function getCountryFieldLayout() {
  return {
    fieldId: '1e445376-d280-4cda-9ffa-18b61c2881c7',
    row: 0,
    column: 0,
    width: 12,
    height: 1
  };
}
//# sourceMappingURL=get-country-field.js.map